import { useEffect } from "react";
import InvitationOptions from "./InvitationOptions";

const Stepper = ({
  currentStep,
  setCurrentStep,
  children,
  onNext,
  onBack,
  onFinish,
  loading,
  buttonRef,
  isDropdownOpen,
  setIsDropdownOpen,
  optionsRef,
  formData,
  setFormData,
  handleSubmit,
}) => {
  useEffect(() => {
    if (window.HSStaticMethods && window.HSStaticMethods.autoInit) {
      window.HSStaticMethods.autoInit();
    }
  }, []);

  return (
    <div
      data-hs-stepper=""
      className="w-full flex flex-col items-center justify-center"
    >
      {/* Stepper Nav */}
      <ul className="relative flex flex-row gap-x-10 items-center justify-between mx-auto">
        <li
          className="flex items-center gap-x-2 shrink basis-0 flex-1 group"
          data-hs-stepper-nav-item='{"index": 1}'
        >
          <span
            onClick={() => setCurrentStep(1)}
            className="min-w-7 min-h-7 group inline-flex items-center text-xs align-middle"
          >
            <span className="size-7 flex justify-center items-center shrink-0 bg-gray-100 font-medium text-gray-800 rounded-full group-focus:bg-gray-200 hs-stepper-active:bg-teal-600 hs-stepper-active:text-white hs-stepper-success:bg-teal-600 hs-stepper-success:text-white hs-stepper-completed:bg-teal-500 hs-stepper-completed:group-focus:bg-teal-600      :bg-gray-600  :bg-teal-500  :bg-blue-500  :bg-teal-500  :group-focus:bg-teal-600">
              <span className="hs-stepper-success:hidden hs-stepper-completed:hidden">
                1
              </span>
              <svg
                className="hidden shrink-0 size-3 hs-stepper-success:block"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </span>
            <span className="ms-2 text-sm font-medium text-gray-800   hidden sm:block">
              Osnovne informacije
            </span>
          </span>
          <div className="w-full h-px flex-1 bg-gray-200 group-last:hidden hs-stepper-success:bg-teal-600 hs-stepper-completed:bg-teal-600    :bg-teal-600  :bg-teal-600"></div>
        </li>
        <li
          className="flex items-center gap-x-2 shrink basis-0 flex-1 group"
          data-hs-stepper-nav-item='{"index": 2}'
        >
          <span
            onClick={() => setCurrentStep(2)}
            className="min-w-7 min-h-7 group inline-flex items-center text-xs align-middle"
          >
            <span className="size-7 flex justify-center items-center shrink-0 bg-gray-100 font-medium text-gray-800 rounded-full group-focus:bg-gray-200 hs-stepper-active:bg-teal-600 hs-stepper-active:text-white hs-stepper-success:bg-teal-600 hs-stepper-success:text-white hs-stepper-completed:bg-teal-500 hs-stepper-completed:group-focus:bg-teal-600      :bg-gray-600  :bg-teal-500  :bg-blue-500  :bg-teal-500  :group-focus:bg-teal-600">
              <span className="hs-stepper-success:hidden hs-stepper-completed:hidden">
                2
              </span>
              <svg
                className="hidden shrink-0 size-3 hs-stepper-success:block"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </span>
            <span className="ms-2 text-sm font-medium text-gray-800   hidden sm:block">
              Dizajn pozivnice
            </span>
          </span>
          <div className="w-full h-px flex-1 bg-gray-200 group-last:hidden hs-stepper-success:bg-teal-600 hs-stepper-completed:bg-teal-600    :bg-teal-600  :bg-teal-600"></div>
        </li>

        <li
          className="flex items-center gap-x-2 shrink basis-0 flex-1 group"
          data-hs-stepper-nav-item='{"index": 3}'
        >
          <span
            onClick={() => setCurrentStep(3)}
            className="min-w-7 min-h-7 group inline-flex items-center text-xs align-middle"
          >
            <span className="size-7 flex justify-center items-center shrink-0 bg-gray-100 font-medium text-gray-800 rounded-full group-focus:bg-gray-200 hs-stepper-active:bg-teal-600 hs-stepper-active:text-white hs-stepper-success:bg-teal-600 hs-stepper-success:text-white hs-stepper-completed:bg-teal-500 hs-stepper-completed:group-focus:bg-teal-600      :bg-gray-600  :bg-teal-500  :bg-blue-500  :bg-teal-500  :group-focus:bg-teal-600">
              <span className="hs-stepper-success:hidden hs-stepper-completed:hidden">
                3
              </span>
              <svg
                className="hidden shrink-0 size-3 hs-stepper-success:block"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </span>
            <span className="ms-2 text-sm font-medium text-gray-800   hidden sm:block">
              Odabir paketa
            </span>
          </span>
        </li>
        <li
          className={`flex items-center gap-x-2 shrink basis-0 flex-1 group ${
            currentStep === 2 ? "block" : "hidden"
          }`}
        >
          <span className="min-w-7 min-h-7 group inline-flex items-center text-xs align-middle">
            <span className="size-7 flex justify-center items-center shrink-0 bg-gray-100 font-medium text-gray-800 rounded-full group-focus:bg-gray-200 hs-stepper-active:bg-teal-600 hs-stepper-active:text-white hs-stepper-success:bg-teal-600 hs-stepper-success:text-white hs-stepper-completed:bg-teal-500 hs-stepper-completed:group-focus:bg-teal-600      :bg-gray-600  :bg-teal-500  :bg-blue-500  :bg-teal-500  :group-focus:bg-teal-600">
              <InvitationOptions
                loading={loading}
                buttonRef={buttonRef}
                isDropdownOpen={isDropdownOpen}
                setIsDropdownOpen={setIsDropdownOpen}
                optionsRef={optionsRef}
                formData={formData}
                setFormData={setFormData}
                handleSubmit={handleSubmit}
              />{" "}
            </span>
            <span className="ms-2 text-sm font-medium text-gray-800   hidden sm:block">
              Opcije pozivnice
            </span>
          </span>
        </li>
      </ul>

      {/* Stepper Content */}
      <div className="mt-5 sm:mt-8">
        {children}

        {/* Button Group */}
        <div className="mt-8 flex justify-between items-center gap-x-2">
          <button
            type="button"
            className="mx-auto py-2 px-3 inline-flex items-center gap-x-1 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none        :bg-neutral-700  :bg-neutral-700"
            data-hs-stepper-back-btn=""
            onClick={onBack}
            disabled={currentStep === 1}
          >
            <svg
              className="shrink-0 size-4"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="m15 18-6-6 6-6"></path>
            </svg>
            Natrag
          </button>
          {currentStep === 1 || currentStep === 2 ? (
            <button
              type="button"
              className="mx-auto py-2 px-3 inline-flex items-center gap-x-1 text-sm font-medium rounded-lg border border-transparent bg-teal-600 text-white hover:bg-teal-700 focus:outline-none focus:bg-teal-700 disabled:opacity-50 disabled:pointer-events-none"
              data-hs-stepper-next-btn=""
              onClick={onNext}
            >
              Dalje
              <svg
                className="shrink-0 size-4"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="m9 18 6-6-6-6"></path>
              </svg>
            </button>
          ) : (
            <button
              type="button"
              className="mx-auto py-2 px-3 inline-flex items-center gap-x-1 text-sm font-medium rounded-lg border border-transparent bg-teal-600 text-white hover:bg-teal-700 focus:outline-none focus:bg-teal-700 disabled:opacity-50 disabled:pointer-events-none"
              data-hs-stepper-finish-btn=""
              onClick={onFinish}
              disabled={loading}
            >
              {loading
                ? "Učitavanje..."
                : formData.id
                ? "Uredi pozivnicu"
                : "Kreiraj pozivnicu"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Stepper;
